import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function PainSection() {
  return <section id="pain-section" className="py-24 md:py-32 bg-[#0a1628] relative overflow-hidden" data-id="element-174">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#1e3a5f] to-transparent" data-id="element-175" />

      <div className="max-w-3xl mx-auto px-6" data-id="element-176">
        <FadeIn data-id="element-177">
          <div className="text-center mb-16" data-id="element-178">
            <h2 className="text-3xl md:text-5xl text-white mb-6" data-id="element-179">
              El patrón real{' '}
              <span className="text-[#64748b] text-2xl md:text-3xl block mt-2 font-normal font-sans" data-id="element-180">
                (lo que te está pasando)
              </span>
            </h2>
          </div>
        </FadeIn>

        <div className="space-y-12 text-lg md:text-xl text-gray-300 leading-relaxed" data-id="element-181">
          <FadeIn data-id="element-182">
            <p data-id="element-183">Tú no tienes "un problema de motivación".</p>
            <p className="text-white font-semibold mt-2 text-2xl" data-id="element-184">
              Tienes un problema de arquitectura diaria.
            </p>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-185">
            <p data-id="element-186">Porque cada vez que intentas cambiar, haces lo mismo:</p>

            <div className="mt-8 relative pl-8 border-l-2 border-[#1e3a5f] space-y-6" data-id="element-187">
              {['Te emocionas', 'Te exiges demasiado', 'Fallas', 'Te culpas', 'Abandonas', 'Vuelves a empezar semanas después'].map((item, index) => <div key={index} className="flex items-center" data-id="element-188">
                  <span className="absolute -left-[9px] w-4 h-4 rounded-full bg-[#0a1628] border-2 border-[#d4af37]" data-id="element-189" />
                  <span className="text-gray-200" data-id="element-190">{item}</span>
                </div>)}
            </div>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-191">
            <div className="bg-[#1e3a5f]/30 p-8 rounded-lg border border-[#1e3a5f] mt-12 text-center" data-id="element-192">
              <p className="text-xl md:text-2xl italic font-serif text-[#d4af37]" data-id="element-193">
                "Y así se te va el año."
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.6} data-id="element-194">
            <p className="text-center text-xl md:text-2xl mt-12" data-id="element-195">
              Lo que estás perdiendo no es un hábito.
              <br data-id="element-196" />
              <span className="text-white font-bold border-b-2 border-[#d4af37]" data-id="element-197">
                Es confianza personal.
              </span>
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}